exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-item[data-v-651d5643]{margin-top:8px}.url-item[data-v-651d5643]{margin-bottom:12px}", ""]);

// exports
